import React, { useState, useMemo } from 'react';
import RewardList from '../rewardListPresentation';
import useBadgeList from '../hooks/useGetBadgeList';
import useRewardDetails from '../hooks/useRewardDetails';

const ADMIN_ROLES = ['admin', 'superadmin', 'supportadmin'];

const naturalSortBadges = (badges) => {
	if (!badges || badges.length === 0) return badges;
	return [...badges].sort((a, b) => {
		const nameA = (a.name || a.label || '').toLowerCase();
		const nameB = (b.name || b.label || '').toLowerCase();
		return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
	});
};

const RewardListContainer = (props) => {
	const {
		handleIconClickEvent,
		title,
		titleLink,
		titleLinkText,
		badgeType,
		shouldRefresh,
		setShouldRefresh,
		isDetailsShown,
		isPointsShown = false,
		getMyBadge = false,
		isIssuedVisible = false,
		currentUser,
		client,
		badges,
		useCustomData = false,
		customHeight,
		hasMore: customHasMore = false,
		fetchMoreData: customFetchMoreData = () => {},
		isLoadingMore = false,
	} = props;

	const [isViewRewardModalVisible, setIsViewRewardModalVisible] =
		useState(false);

	const { rewardDetails, isModalLoaderVisible, handleOpenViewReward } =
		useRewardDetails(setIsViewRewardModalVisible, currentUser, client);

	let { isLoading, badgeList, hasMore, fetchMoreData } = useBadgeList(
		badgeType,
		shouldRefresh,
		setShouldRefresh,
		getMyBadge,
		currentUser,
		client
	);

	const isAdminView = ADMIN_ROLES.includes(currentUser?.role?.toLowerCase()) && currentUser?.displayAs === 'admin';

	const finalBadgeList = useMemo(() => {
		const list = useCustomData ? badges : badgeList;
		const filtered = isAdminView ? list : list?.filter((badge) => badge.visibility !== false);
		return naturalSortBadges(filtered);
	}, [useCustomData, badges, badgeList, isAdminView]);
	const finalIsLoading = useCustomData ? isLoadingMore : isLoading;
	const finalHasMore = useCustomData ? customHasMore : hasMore;
	const finalFetchMoreData = useCustomData
		? customFetchMoreData
		: fetchMoreData;

	const handleCloseViewReward = () => {
		setIsViewRewardModalVisible(false);
	};
	return (
		<>
			{finalBadgeList?.length > 0 || badgeType === 'On-the-Spot' ? (
				<RewardList
					handleIconClickEvent={handleIconClickEvent}
					title={title}
					titleLink={titleLink}
					titleLinkText={titleLinkText}
					badgeType={badgeType}
					hasMore={finalHasMore}
					isLoading={finalIsLoading}
					badgeList={finalBadgeList}
					fetchMoreData={finalFetchMoreData}
					isDetailsShown={isDetailsShown}
					isPointsShown={isPointsShown}
					handleCloseViewReward={handleCloseViewReward}
					isViewRewardModalVisible={isViewRewardModalVisible}
					rewardDetails={rewardDetails}
					isModalLoaderVisible={isModalLoaderVisible}
					handleOpenViewReward={handleOpenViewReward}
					getMyBadge={getMyBadge}
					isIssuedVisible={isIssuedVisible}
					currentUser={currentUser}
					customHeight={customHeight}
				/>
			) : null}
		</>
	);
};

export default RewardListContainer;
